import $ from 'jquery';
import {Swiper, Autoplay, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Navigation]);

$('.swiper-product-slider').each(function () {
    const $self = $(this);
    const productSlider = new Swiper(this, {
        watchOverflow: true,
        autoHeight: true,
        spaceBetween: 15,
        slidesPerView: 1,
        cssMode: true,
        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            800: {
                slidesPerView: 3,
            },
            1000: {
                slidesPerView: 4
            },
            1225: {
                slidesPerView: 5
            }
        },
        navigation: {
            nextEl: $self.closest('.section').find('.product-swiper-button-next')[0],
            prevEl: $self.closest('.section').find('.product-swiper-button-prev')[0],
        }
    });
});

